/**
 * @generated SignedSource<<8ea6bbc8a62b70149796ed2aaccf53db>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type EmployeeWorkStatus = "NOT_WORKING" | "WORKING";
export type TodoStatus = "DONE" | "PENDING";
import { FragmentRefs } from "relay-runtime";
export type TodoOverviewListItemMediumFooter_Todo$data = {
  readonly assigned: ReadonlyArray<{
    readonly employee: {
      readonly name: string;
    } | null;
  }>;
  readonly assignedRoles: ReadonlyArray<{
    readonly role: {
      readonly employees: ReadonlyArray<{
        readonly id: string;
        readonly isLinkedToViewer: boolean;
        readonly name: string;
        readonly workStatus: EmployeeWorkStatus;
      }>;
      readonly name: string;
    };
  }>;
  readonly commentCount: number;
  readonly expireAt: string | null;
  readonly subTodos: ReadonlyArray<{
    readonly __typename: "Todo";
    readonly status: TodoStatus;
  }> | null;
  readonly tags: ReadonlyArray<{
    readonly color: string;
    readonly id: string;
    readonly title: string;
  }>;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetTodoListItemDeadline_todo">;
  readonly " $fragmentType": "TodoOverviewListItemMediumFooter_Todo";
};
export type TodoOverviewListItemMediumFooter_Todo$key = {
  readonly " $data"?: TodoOverviewListItemMediumFooter_Todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoOverviewListItemMediumFooter_Todo">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoOverviewListItemMediumFooter_Todo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TodoCategoryTag",
      "kind": "LinkedField",
      "name": "tags",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "color",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WidgetTodoListItemDeadline_todo"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "expireAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AssignedRole",
      "kind": "LinkedField",
      "name": "assignedRoles",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EmployeeRole",
          "kind": "LinkedField",
          "name": "role",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Employee",
              "kind": "LinkedField",
              "name": "employees",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isLinkedToViewer",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "workStatus",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Todo",
      "kind": "LinkedField",
      "name": "subTodos",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AssignedEmployee",
      "kind": "LinkedField",
      "name": "assigned",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Employee",
          "kind": "LinkedField",
          "name": "employee",
          "plural": false,
          "selections": [
            (v1/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "commentCount",
      "storageKey": null
    }
  ],
  "type": "Todo",
  "abstractKey": null
};
})();

(node as any).hash = "b79f596b41017ba5016cd8523e0c3b83";

export default node;
